import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoutImg from 'assets/img/icons/spot-illustrations/45.png';
import { contextApp } from 'context';
import { toast } from 'react-toastify';

const LogoutContent = ({ layout, titleTag: TitleTag }) => {
 const { logout /* setLogout */ } = contextApp();
 const navigate = useNavigate();

 useEffect(() => {
  console.log(logout);
  if (logout?.fullName) toast.success(`Hasta pronto ${logout?.fullName.toLowerCase().replace(/\b\w/g, l => l.toUpperCase())} 👌`);
  setTimeout(navigate, 30000, '/');
 }, []);

 return (
  <>
   {logout?.avatar ? (
    <Image src={logout.avatar} roundedCircle thumbnail width={150} />
   ) : (
    <img className="d-block mx-auto mb-4" src={logoutImg} alt="shield" width={100} />
   )}

   <TitleTag>¡Hasta pronto!</TitleTag>
   <p>
    Gracias por usar inmóvilii. Usted <br className="d-none d-sm-block" />
    ahora estas fuera de sesión.
   </p>
   <Button as={Link} color="primary" size="sm" className="mt-3" to={`/authentication/${layout}/login`}>
    <FontAwesomeIcon icon="chevron-left" transform="shrink-4 down-1" className="me-1" />
    Volver a Iniciar.
   </Button>
  </>
 );
};

LogoutContent.propTypes = {
 layout: PropTypes.string,
 titleTag: PropTypes.string
};

LogoutContent.defaultProps = {
 layout: 'simple',
 titleTag: 'h4'
};

export default LogoutContent;
